module.exports = __webpack_public_path__ + "img/notification.0c268355.svg";